module.exports = __webpack_public_path__ + "static/media/mycart_logo.dd0cced2.png";